import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { connectToStores } from 'fluxible-addons-react';
import throttle from 'utils/throttle';
import TextInputAdd from '../../../common/inputs/customs/text-input-add';
import validateIPaddress from '../../../../services/validator';
import { SUCCESS, LOADING, NONE, ERROR } from '../../../../models/request-status';
import ValidationMessageTip from '../../../topics/components/ValidationMessageTip';
import { scrollToTop } from '../../../../utils/client';
import { addBlockedIp } from '../../users/state/actions/add-user';
import { removeBlockedIp } from '../../users/state/actions/remove-user';
import { fetchBlockedIps } from '../../users/state/actions/fetch-users';
import { TModerationUser } from '../../users/state/types';
import { getUsersOfType } from '../../users/state/reducer';
import BlacklistItem from './item';

const SCROLL_EDGE_TRESHOLD = 0;

const mapDispatchToProps = dispatch => ({
  fetchBlockedIps: (props = {}) => {
    dispatch(fetchBlockedIps(props));
  },
  addBlockedIps: (props = {}) => {
    dispatch(addBlockedIp(props));
  },
  removeBlockedIp: (props = {}) => {
    dispatch(removeBlockedIp(props));
  }
});

const mapStateToProps = state => {
  const { users, ...rest } = getUsersOfType(state, TModerationUser.BlockedIps);
  return {
    ...rest,
    ips: users.map(ip => ({
      ip
    }))
  };
};

class BlacklistedIps extends Component {
  static displayName = 'BlacklistedIps';

  static propTypes = {
    spotId: PropTypes.string.isRequired,
    ips: PropTypes.array,
    isLoading: PropTypes.bool,
    totalIps: PropTypes.number,
    fetchBlockedIps: PropTypes.func,
    addBlockedIps: PropTypes.func,
    removeBlockedIp: PropTypes.func,
    isViewOnlyMode: PropTypes.bool
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      disabledAddButton: true,
      value: null,
      status: NONE,
      showValidationMessageTip: false
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.isIpExists = this.isIpExists.bind(this);
    this.showErrorMessage = this.showErrorMessage.bind(this);
    this.loadNextPage = throttle(this.loadNextPage, 500);
  }

  componentDidMount() {
    this.props.fetchBlockedIps();
  }

  blacklistIp(ip) {
    this.props.addBlockedIps({ ip });
    this.setState({ disabledAddButton: true });
  }

  onIpChange(ip) {
    var { disabledAddButton, status, showValidationMessageTip } = this.state;

    disabledAddButton = true;
    status = ERROR;
    if (validateIPaddress(ip)) {
      if (!this.isIpExists(ip)) {
        disabledAddButton = false;
        status = SUCCESS;
        showValidationMessageTip = false;
      } else {
        showValidationMessageTip = true;
      }
    }
    this.setState({ disabledAddButton, value: ip, status, showValidationMessageTip }, () => {
      if (showValidationMessageTip) {
        this.showErrorMessage();
      }
    });
  }

  isIpExists(ip) {
    let { ips } = this.props;
    return ips.filter(el => el.ip === ip).length > 0;
  }

  showErrorMessage() {
    scrollToTop();
    setTimeout(() => this.setState({ showValidationMessageTip: false }), 4000);
  }

  handleScroll() {
    let { ipsList } = this.refs;
    var scrollFromTop = ipsList.scrollTop;
    var scrollFromBottom = ipsList.scrollHeight - scrollFromTop - ipsList.clientHeight;
    if (scrollFromBottom <= SCROLL_EDGE_TRESHOLD) {
      this.loadNextPage();
    }
  }

  loadNextPage() {
    var { isLoading, totalIps, ips, spotId } = this.props;
    if (!isLoading && (!ips || ips.length < totalIps)) {
      this.props.fetchBlockedIps({
        offset: ips ? ips.length : 0
      });
    }
  }

  @autobind
  removeBlacklistedIp(ip) {
    this.props.removeBlockedIp({ ip });
  }

  render() {
    var { ips, spotId, isViewOnlyMode } = this.props;
    var { value, disabledAddButton, status, showValidationMessageTip } = this.state;

    return (
      <div className="blacklisted">
        <TextInputAdd
          title="Blocked IPs"
          description="Comments from these IPs will be automatically rejected."
          placeholder="Type IP address..."
          onClick={this.blacklistIp.bind(this)}
          onChange={this.onIpChange.bind(this)}
          disabledAddButton={disabledAddButton || isViewOnlyMode}
          value={value}
          status={status}
        />
        <ValidationMessageTip
          show={showValidationMessageTip}
          customMessage={'IP address is already blacklisted.'}
        />
        <div className="blacklisted-list" ref="ipsList" onScroll={this.handleScroll}>
          {ips.map(ip => (
            <BlacklistItem
              onClick={this.removeBlacklistedIp}
              key={ip.ip}
              ip={ip}
              spotId={spotId}
              isViewOnlyMode={isViewOnlyMode}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlacklistedIps);
